<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"></slot>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Downloads
      </v-card-title>
      <v-card-text class="px-0">
        <empty-state
          v-if="isLoadingProducts && !archivedProducts"
          color="accent"
        >
          <template v-slot:icon>
            <v-icon class="spinning" color="accent">mdi-sync</v-icon>
          </template>
          <template v-slot:description>
            Carregando ...
          </template>
        </empty-state>
        <empty-state
          v-else-if="productsIsEmpty && !archivedProducts"
        >
          <template v-slot:icon>
            <v-icon>mdi-folder-open</v-icon>
          </template>
          <template v-slot:description>
            Nenhum produto encontrado
          </template>
        </empty-state>
        <v-expansion-panels accordion v-else-if="!archivedProducts">
          <v-expansion-panel
            v-if="modelo.length > 0"
          >
            <v-expansion-panel-header>MODELOS DIGITAIS</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list
                rounded
              >
                <v-list-item-group
                  id="products-download-list"
                >
                  <v-list-item
                    :id="textId(item.name)"
                    v-for="item in modelo"
                    :key="item.name"
                    @click="openLink(item)"                    
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-image</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>                    
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            v-if="curvas.length > 0"
          >
            <v-expansion-panel-header>CURVAS DE NÍVEL</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list
                rounded
              >
                <v-list-item-group
                  id="products-download-list"
                >
                  <v-list-item
                    :id="textId(item.name)"
                    v-for="item in curvas"
                    :key="item.name"
                    @click="openLink(item)"                    
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-image</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>                      
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            v-if="nuvem.length > 0"
          >
            <v-expansion-panel-header>NUVEM DE PONTOS</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list
                rounded
              >
                <v-list-item-group
                  id="products-download-list"
                >
                  <v-list-item
                    :id="textId(item.name)"
                    v-for="item in nuvem"
                    :key="item.name"
                    @click="openLink(item)"                    
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-image</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>                      
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            v-if="ortomosaico.length > 0"
          >
            <v-expansion-panel-header>ORTOMOSAICO</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list
                rounded
              >
                <v-list-item-group
                  id="products-download-list"
                >
                  <v-list-item
                    :id="textId(item.name)"
                    v-for="item in ortomosaico"
                    :key="item.name"
                    @click="openLink(item)"                    
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-image</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>                      
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
          >
            <v-expansion-panel-header>RELATÓRIOS</v-expansion-panel-header>
            <v-expansion-panel-content>
              <empty-state
                v-if="isLoadingReports"
                color="accent"
              >
                <template v-slot:icon>
                  <v-icon class="spinning" color="accent">mdi-sync</v-icon>
                </template>
                <template v-slot:description>
                  Carregando relatórios
                </template>
              </empty-state>
              <empty-state
                v-else-if="reportsIsEmpty"
              >
                <template v-slot:icon>
                  <v-icon>mdi-folder-open</v-icon>
                </template>
                <template v-slot:description>
                  Nenhum relatório encontrado
                </template>
              </empty-state>
              <v-list
                v-else
                rounded
              >
                <v-list-item-group
                  id="reports-download-list"
                >
                  <v-list-item
                    v-for="item in reports"
                    :key="item.name"
                    :href="item.url"
                    target="_blank"                    
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-file-pdf-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>                      
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            v-if="outros.length > 0"
          >
            <v-expansion-panel-header>OUTROS</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list
                rounded
              >
                <v-list-item-group
                  id="products-download-list"
                >
                  <v-list-item
                    :id="textId(item.name)"
                    v-for="item in outros"
                    :key="item.name"
                    @click="openLink(item)"                    
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-image</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>                      
            </v-expansion-panel-content>
          </v-expansion-panel>                                               

        </v-expansion-panels>              
        <!-- <v-list
          v-else-if="!archivedProducts"
          rounded
        >
          <v-list-item-group
            id="products-download-list"
          >
            <v-list-item
              :id="textId(item.name)"
              v-for="item in products"
              :key="item.name"
              @click="openLink(item)"                    
            >
              <v-list-item-icon>
                <v-icon>mdi-image</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{item.name}}</v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list> -->
        <empty-state
          v-else
          color="accent"
        >
          <template v-slot:icon>
            <v-icon v-if="processingStatus == 'UNARCHIVING'" color="accent">mdi-calendar-clock</v-icon>
            <v-icon v-else color="accent">mdi-archive</v-icon>
          </template>
          <template v-slot:description>
            <span
              class="caption"
              v-if="processingStatus == 'UNARCHIVING'"
            >
              O desarquivamento dos produtos já foi solicitado e pode levar de 5 a 12 horas
            </span>                    
            <span class="caption" v-else>
              Os produtos desse processamento estão arquivados. Clique no botão abaixo para solicitar desarquivamento
            </span>
            <br><br>
            <v-btn
              text
              outlined
              color="accent"
              :loading="isRequestingUnarchiving"
              :disabled="isRequestingUnarchiving"
              v-if="archivedProducts"
              @click="request_unarchive"
            >
              DESARQUIVAR
            </v-btn>
          </template>
        </empty-state>        
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="close-processing-downloads"
          color="primary"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
    <span id="product-url-container" v-show="false">{{ ortomosaicoUrl }}</span>
  </v-dialog>
</template>

<script>
  import {listProcessingProducts, listProcessingReports, createEventInternal} from "../../api/api-project"
  import {isEmpty} from "lodash/lang"
  import EmptyState from "../Helpers/EmptyState"
  import {PROCESSING_STATUS_DETAILS} from "../../helpers/processings/constants"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {DIALOG_TYPES, DialogOptions} from "../../helpers/dialogs"
    import {
    getProcessingRequestUnarchive,
  } from "../../api/api-project"  

  export default {
    name: "ProcessingDownloads",
    components: {EmptyState},
    props: {
      idProcessing: {
        type: String,
        required: true,
      },
      processing: {
        required: true,
      },      
    },   
    data: () => ({
      ortomosaicoUrl: null,
      tab: null,
      active: false,
      isLoadingReports: false,
      isLoadingProducts: false,
      isRequestingUnarchiving: false,
      reports: [],
      products: [],

      curvas: [],
      nuvem: [],
      ortomosaico: [],
      outros: [],
      archivedProducts: false
    }),
    methods: {
      textId(val) {
        return `product-${val.toLowerCase().replace(/\s/g, '')}`;
      },
      request_unarchive() {
        this.$dialog(new DialogOptions({
          title: "Desarquivar Processamento",
          content: "O processo para desarquivar pode levar de 5 a 12 horas. Deseja solicitar o desarquivamento?",
          onConfirm: this.unarchive,
          type: DIALOG_TYPES.CONFIRM,
        }))
      },
      unarchive() {
        this.isRequestingUnarchiving = true
        getProcessingRequestUnarchive(this.$apiAuth.getAuthToken(), this.processing["id_processing"])
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Desarquivamento solicitado com sucesso!",
              type: NOTIFICATION_TYPES.SUCCESS,
            })) 
            this.processing["ab_products_status"] = 'UNARCHIVING'
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Não conseguimos solicitar o desarquivamento do processamento. Tente novamente mais tarde.",
              type: NOTIFICATION_TYPES.ERROR,
            })) 
          })
          .finally(() => {
            this.isRequestingUnarchiving = false
          })
      },      
      retiraAcento(palavra){  
        var com_acento = 'áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ´`^¨~- ';    
        var sem_acento = 'aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC     __';  
        let l; let l2;
        for (l in palavra){  
          for (l2 in com_acento){  
            if (palavra[l] == com_acento[l2]){  
              palavra=palavra.replace(palavra[l],sem_acento[l2]);  
            }  
          }  
        }
        palavra = palavra.replace('__', '_')
        return palavra.toUpperCase();  
      }, 
      openLink(item) {
        let event_name = this.retiraAcento(item.name);
        event_name = 'DOWNLOAD_' + event_name

        const authToken = this.$apiAuth.getAuthToken()

        let data_send = {
          "event_name": event_name,
          "cd_processing": this.idProcessing
        }
        createEventInternal(authToken, data_send)
        .then(() => {
          console.log("INTERNAL EVENT CREATED")
        })
        .catch(() => {
          console.log("ERROR CREATE INTERNAL EVENT")
        })
        this.ortomosaicoUrl = item.url
        window.open(item.url, "_blank");    
      },
      onOpen() {
        this.isLoadingReports = true
        this.isLoadingProducts = true

        const authToken = this.$apiAuth.getAuthToken()
        listProcessingReports(authToken, this.idProcessing)
          .then((res) => {
            this.reports = res.data.data.reports
          })
          .finally(() => {
            this.isLoadingReports = false
          })

        listProcessingProducts(authToken, this.idProcessing)
          .then((res) => {
            this.products = res.data.data.products
            this.products = this.products.sort(function(a, b) {
                return a.name.localeCompare(b.name)
            });
            this.archivedProducts = res.data.data.archived_products
            
            this.modelo = this.products.filter((products) => products.name.includes('Modelo'))
            this.curvas = this.products.filter((products) => products.name.includes('Curvas'))
            this.nuvem = this.products.filter((products) => products.name.includes('Nuvem'))
            this.ortomosaico = this.products.filter((products) => products.name.includes('Ortomosaico'))
            this.outros = this.products.filter((products) => !products.name.includes('Modelo') && !products.name.includes('Curvas') && !products.name.includes('Nuvem') && !products.name.includes('Ortomosaico'))
          })
          .finally(() => {
            this.isLoadingProducts = false
          })
      },
    },
    computed: {
      reportsIsEmpty() {
        return isEmpty(this.reports)
      },
      productsIsEmpty() {
        return isEmpty(this.products)
      },
      processingStatus() {
        return this.processing["ab_products_status"]
      },
      processingStatusText() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_products_status"]]).name
      }, 
      isAchivedOrUnarchiving() {
        if (this.processing["ab_products_status"] != 'ARCHIVED' & this.processing["ab_products_status"] != 'UNARCHIVING') {
          return false
        } else {
          return true
        }
      },           
      isAchivedOrUnarchiving_() {
        if (this.processingStatusText != 'Processamento arquivado' & this.processingStatusText != 'Desarquivamento solicitado') {
          return false
        } else {
          return true
        }
      }            
    },
    watch: {
      active(newValue) {
        if (newValue) this.onOpen()
      },
    },
  }
</script>

<style scoped lang="scss">
  .center {
    text-align: center;
  }
</style>
